module.exports = __webpack_public_path__ + "static/media/PerfilAccount.4d355cc9.svg";